function getCustomControlDefaultValue(customComponentName) {
  switch (customComponentName) {
    case 'StatesSelector':
    case 'ServiceProvider':
    case 'BrandsAll':
    case 'ProductLineAll':
    case 'ServiceAdministratorClient':
    case 'ServiceProviderRecommendedLocations':
    case 'ServiceProviderLocationNumber':
    case 'DynamicDateRangePicker':
    case 'JobStatusSelector':
    case 'DispatchStatusSelector':
    case 'ClaimStatusSelector':
    case 'DataExportHistoryStatusSelector':
    case 'ServiceProviderMainContact':
    case 'AddressValidator':
    case 'UserRoleSelect':
    case 'ValidatedAddress':
    case 'Industry':
    case 'SDButtonsForm':
    case 'Schedule':
    case 'RegisterOnly':
      return null;
    case 'ContractorComplianceMultiSelect':
    case 'ActiveInActiveEnum':
    case 'ActiveInActiveStatus':
    case 'DataExportHistoryExportType':
    case 'PhoneNumber':
    case 'YesNo':
    case 'UserStatusSelect':
    case 'InsightConfigName':
    case 'InsightConfigValue':
    case 'IssuePrioritySelect':
    case 'IssueReporterSelector':
    case 'IssueReporterCompanySelector':
    case 'IssueReporterCompanyTypeSelect':
    case 'IssueCompanySelector':
    case 'IssueComponentSelect':
    case 'IssueResolutionSelect':
    case 'IssueServiceAdministratorSelector':
    case 'IssueStatusSelect':
    case 'IssueTypeSelect':
    case 'IssueActivityTypeSelect':
    case 'IssueAssigneeSelector':
      return '';
    case 'AttachmentList':
    case 'IndustrySelector':
      return [];
    default:
      throw new Error(
        `Plaase configure default value for ${customComponentName} in src/product-framework/utils/getDefaultValueByControl.jsx`,
      );
  }
}

/*
 Used in packages/frontend/src/ui-framework/components/Forms/FormSearchAdvanced.jsx to set default values if not provided
*/
function getDefaultValueByControl({ field }) {
  switch (field?.control) {
    case 'custom':
      return getCustomControlDefaultValue(field.customComponent);
    default:
      return '';
  }
}

export default getDefaultValueByControl;
